import {FC} from 'react';
import {AUCTION, FOUND_THE_MISSION, TOTAL_RAISED, TABLES_SALES} from '@/utils/constants';
import {Box} from '@mui/material';
import {CircularsStyle} from './Circulars.style';
import {useAppSelector} from '@/store/hooks';
import {getDashboardStatisticsSelector} from '@/store/organization-dashboard';
import MoneyAmountInfoItem from '@/components/Organization/Dashboard/Statistics/MoneyAmountInfo/MoneyAmountInfoItem';
import {IOrganizationDashboardStatistics} from '@/utils/types';

const Circulars: FC = () => {
	const statistics = useAppSelector(getDashboardStatisticsSelector) as IOrganizationDashboardStatistics;

	const {
		moneyColl,
		moneyOutstanding,
		tableColl,
		tableOutstanding,
		auctionColl,
		auctionOutstanding,
		fundMissionColl,
		fundMissionOutstanding,
	} = statistics;

	return (
		<Box sx={CircularsStyle.mainWrapper}>
			<MoneyAmountInfoItem title={TOTAL_RAISED} collected={moneyColl} outstanding={moneyOutstanding} />
			<MoneyAmountInfoItem title={TABLES_SALES} collected={tableColl} outstanding={tableOutstanding} />
			<MoneyAmountInfoItem title={AUCTION} collected={auctionColl} outstanding={auctionOutstanding} />
			<MoneyAmountInfoItem title={FOUND_THE_MISSION} collected={fundMissionColl} outstanding={fundMissionOutstanding} />
		</Box>
	);
};

export default Circulars;
